/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch } from "react-redux";
import FileBase64 from "react-file-base64";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";

import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";

// import {  } from "@material-ui/core";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton,
} from "@material-ui/core"; // Remove the unused imports for CHG0073013
import { useHistory } from "react-router-dom";
import InputAdornment from "@material-ui/core/InputAdornment";
import { SearchOutlined } from "@material-ui/icons";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ClearIcon from "@mui/icons-material/Clear";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TablePagination from "@mui/material/TablePagination"; 
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { MdReplay } from "react-icons/md";
import { MenuItem } from "@mui/material/";
import styles from "./IndirectProjectReport.module.css";
import Truckloading from "../CvLoader/Cvloader";

import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField,
} from "../FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex,
} from "../../constants";
import { API } from "../../apis/api";
// import TextIcon from './TextIcon'
import { buildErrorMessage } from "../../apis/calls";
import Table from "../Table/Table";
import ReportTable from '../ReportTableComponent/ReportTable';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import {
  setToast,
  setPORow,
  poSearch,
  fetchChassis,
  setChassisData,
  setAllDetails,
  getInvoice,
} from "../../redux/actions/productsActions";
// import  TableSimple from '../../atomicComponents/TableSimple/TableSimple';
import { setLogin } from '../../redux/features/auth/actions';
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";

const initialState = {
  plant: null,
  part: null,
  aqCommodity: null,
  purchaseCommodity: null,
  supplierCode: null,
  supplierDetails: null,
  supplierName: "",
  supplierLocation: "",
  selectedProject: null,
  selectedPO: null,
  inputFields: {
    purchaseBuyerName: "",
    suppRepresentativeName: "",
    suppRepresentativeContact: "",
    suppRepresentativeEmail: "",
  },
  errors: {},
};
const reducer = (state, action) => {
  switch (action.type) {
    case "update":
      return {
        ...state,
        [action.field]: action.value,
      };
    case "reset":
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
const useStyles = makeStyles((theme) =>
  createStyles({
    smallRadioButton: {
      "& svg": {
        width: "0.7em",
        height: "0.7em",
      },
    },
  })
);

function ReportForm({
  redirectToProcessPage,
  product,
  counter,
  baseUrl,
  auth,
}) {
  const { userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    persArea } = auth;

  let UserRoles = userRole;
  let MangerFlag = UserRoles.includes("M");
  // console.log(UserRoles,"UserRoles", MangerFlag,"MangerFlag")
  let DSFlag = UserRoles.includes("DS");
  let SAFlag = UserRoles.includes("SA");
  let requiredUsers= ["M", "DS", "SA"];
  const userList = userRole.filter(role => requiredUsers.includes(role));
  const[newUsereList,setNewUserList]=useState(userList)
 
  const classes = useStyles();
  const dateRange = [
    { value: "OnDate", label: "Applied Date" },
    { value: "ToDate", label: "Booking Date" },
  ];

  const workAreaList = [
    { value: "all", label: "ALL" },
    { value: "pvbuEng", label: "PV BU Engineering" },
    { value: "cvbuEng", label: "CV BU Engineering" },
    { value: "evbuEng", label: "EV BU Engineering" },
  ];

  const bcNoList = [
    { value: "all", label: "ALL" },
    { value: "0002100010", label: "0002100010" },
    { value: "0002200020", label: "0002200020" },
    { value: "0002200010", label: "0002200010" },
  ];

  const Location = [{ value: "All", label: "All" }];

  let session_flag = "IPB";
  // let session_flag = "BAR";
  // let session_flag = "PBA";

  const Project = [
    { value: "All", label: "All" },
    { value: "Training", label: "Training" },
    { value: "Audit", label: "Audit" },
    { value: "UnionRelease", label: "Union Release" },
    { value: "Seminor / Presentation", label: "Union Release" },
  ];
  const ROW_HEIGHT = 38;
  const [rowsData, setRowsData] = useState({
    loading: false,
    data: [],
    filteredData: [],
  });
  const [poData, setPOData] = useState({
    loading: false,
    data: [],
    filteredData: [],
    last: false,
    number: 0,
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  const { showInternalError } = usePopupManager();
  const { showPopup } = usePopupManager();
  const dispatchNew = useDispatch();
  const history = useHistory();

  const {
    damage,
    invoice,
    plant,
    part,
    aqCommodity,
    purchaseCommodity,
    supplierCode,
    supplierDetails,
    supplierName,
    supplierLocation,
    selectedProject,
    selectedPO,
    inputFields,
    errors,
  } = state;

  const [suppliers, getSuppliers] = useState({ loading: false, data: [] });
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag, setConfirmModal] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam, handleDeleteParam] = useState();
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
    const [tableArray, setTableArray] = useState([]);
  const [allTableData,setAllTableData]=useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [modifiedData, setModifiedData] = useState([]);

  const [toggle, setToggle] = React.useState(false);
  const [loader, setLoader] = React.useState(true);
  const [hover, setHover] = useState({ isHover: false, name: null });
  const [bodyBuilderOption, setBdybuilderOption] = useState([]);
  const [chassisOption, setChassisData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [viewDisplay, setViewDisplay] = useState(false);
  const [loadings, setLoadings] = React.useState(false);
  const [proDetails, setProDetails] = useState("");

  const [companyCodeOption, setCompanyCode] = useState([]);

  const HEIGHT = '200px';
  const FILENAME = 'Indirect_Project_Report';

  const [myState, setState] = React.useState({
    poNo: "",
    stmNo: "",
    chassisNo: null,
    toDate: null,
    fromDate: null,
    bodyBuilder: null,
    checkFlag: false,
    Flag: null,
    UserRole: null,
    tableFlag:false,
  });


 
  

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
  };
  
  const setCount = (count) => {
    setAsnCount(count);
  };
  const handleDate = (date, name) => {
    //  let newvalue = convert(date);
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;
    }
    // let newDate = date.format(DATE_FORMAT.ISO);
    setState((prevData) => ({ ...prevData, [name]: date }));
  };

  // useEffect(() => {
  //   setTableArray(allTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  // }, [rowsPerPage, page])

 

  const strflag = () => {
    var regexp = new RegExp(/^[a-zA-Z0-9 ]+$/);
    let str = myState.chassisNo;
    if (myState.chassisNo == "") {
      return;
    }

    if (regexp.test(str)) {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: false }));
      return true;
    } else {
      setState((prevData) => ({ ...prevData, chassisNoFlagStr: true }));
      return false;
    }
  };

 

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      // console.log([date.getFullYear(), mnth, day].join("-"),"[date.getFullYear(), mnth, day].join("-")")
       return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29

      // return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  };

  const showError = (msg) => {
    showPopup({
      type: MESSAGE_TYPE.FAILURE,
      contextText: MESSAGE_TYPE.FAILURE,
      info: msg,
    });
  };

  const validateInvoiceData = (dateReport) => {
    let fromDate = myState.fromDate;
    let toDate = myState.toDate;
    let getinvoiceDate = myState.toDate;
    let invoiceDate = moment(toDate, "YYYY-MM-DD").valueOf();
    let reportedDate = moment(fromDate, "YYYY-MM-DD").valueOf(); // 'YYYY-MM-DD'
    //  Reported date should not be less than invoice date

    if (invoiceDate > reportedDate) {
      // console.log(
      //   invoiceDate,
      //   "==invoiceDate",
      //   reportedDate,
      //   "dateReport",
      //   "If"
      // );
      return true;
    } else if (invoiceDate == reportedDate) {
      return true;
    } else {
      // console.log(
      //   invoiceDate,
      //   "==invoiceDate",
      //   reportedDate,
      //   "dateReport",
      //   "else"
      // );

      showError("From date should not greater than to date");

      return false;
    }
  };
  const validateDay = () => {
    let startDate = myState.fromDate;
    let endDate = myState.toDate;
    const diffInMs = new Date(endDate) - new Date(startDate);
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    if (diffInDays >= 90) {
      showError("Both date gap should not exceeds 90 days");
      return false;
    } else {
      return true;
    }
  };

  useEffect(()=>{
    if(newUsereList?.length == 1){
      // console.log(newUsereList,'newuserlist')
      setState((prev) => ({
        ...prev,
        UserRole:newUsereList[0]
      }));
    }
  },[newUsereList])

  const handleSubmit = async () => {
    setLoadings(true);
    setRowsPerPage(10)
    setViewDisplay(true);
    setPage(0)
    setState((prevState) => ({ ...prevState, tableFlag: true}));
      let fromDate = convert2(myState.fromDate);
      let toDate = convert2(myState.toDate);
      // console.log(myState.UserRole,"debugger")
      if (myState.UserRole==null || myState.UserRole=="") {
        setLoadings(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please select Role",
        });
        return
      }
      else  if (myState.Flag==null || myState.Flag=="") {
        setLoadings(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please select Booking Date or Approval Date",
        });
        return  
      } 
      if (fromDate == "" || toDate == "") {
        setLoadings(false)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please enter a date",
        });
        return
     
      }
      const isSameOrAfter = moment(fromDate).isAfter(toDate);
      if (isSameOrAfter) {
        setLoadings(false)
        showPopup({
         type: MESSAGE_TYPE.INFORMATION,
         contextText: MESSAGE_TYPE.INFORMATION,
         info: "End Date Should Be Greater Than Or Equal To Start Date",
       });
       setTableArray([])
       setTableData([])
       setState((prev)=>({
         ...prev,
        
       }))
       }
      else{
        let apiFormatedData = {
          co_code: sanitizeCoCodeNumeric(companyCode),
          pers_no: sanitizeNumeric(personNumber),
          user_role:myState.UserRole,
          flag: myState.Flag,
          from_date: fromDate,
          to_date: toDate,
        };
      
    var apiFormatedDataJson = JSON.stringify(apiFormatedData);
    let headerss = new Headers();
    headerss.append("Content-Type", "application/json");
    fetch(`${baseUrl}reports/IndirectProjectReport`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
     
        dispatchNew(setLogin({...auth, recentStatus: response.status}))
        let responsecode=response.status
        if(responsecode===403){
         setLoadings(false);
        }
        return response.json();
        })
      .then((responseJson) => {
        if (responseJson.msg=="Success" && responseJson.data.length != 0) {
          setState((prevState) => ({ ...prevState, tableFlag: true }));
          const finalList = [];
          responseJson.data.map((row, index) => {
            finalList.push({
              id: index,
              ...row,
            });
          });
          setAllTableData(finalList);
          setTableArray(finalList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage));
          setLoadings(false);
        } 
        else if(responseJson.msg=="Success" && responseJson?.data.length == 0) {
          setLoadings(false);
          showPopup({
            type: MESSAGE_TYPE.INFORMATION,
            contextText: MESSAGE_TYPE.INFORMATION,
            info: "No Records Found",
        })
        setAllTableData([]);
        }
        else if(responseJson && responseJson.msg=="Fail")  {
          setLoadings(false);
          setAllTableData([]);
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: responseJson.data,
        })
        } 
        setState((prevState) => ({ ...prevState, tableFlag: true }));
      }).catch((error) => {
        setLoadings(false);
        setAllTableData([]);
        if (error.response) {
          showPopup({
                  type: MESSAGE_TYPE.FAILURE,
                  contextText: MESSAGE_TYPE.FAILURE,
                  info: "Oops! Something went wrong. Please try again later. Please try again later",
              })
        }
        else {
          showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "There might be Network issue, please try after some time",
            })
        }
      });
      };

    }

  const [backgroundColors, setBackgroundColors] = useState({
    processInfoBg: true,
    supplierInfoBg: false,
    poInfoBg: false,
    projectsInfoBg: false,
  });
  const { processInfoBg, supplierInfoBg, poInfoBg, projectsInfoBg } =
    backgroundColors;

  const changeBackgroundColor = (field) =>
    setBackgroundColors((prev) => {
      const newBackgroundColors = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(prev)) {
        if (key === field) newBackgroundColors[key] = true;
        else newBackgroundColors[key] = false;
      }
      return newBackgroundColors;
    });

  const loadSupliers = async () =>
    loadData(getSuppliers, API_RESOURCE_URLS.getSuppliers(), {
      plantCode: plant ? plant.value : null,
      partNumber: part ? part.value : null,
    });
  const handleOpen = () => setIsPopupOpen(true);
  const handleClose = () => setIsPopupOpen(false);
  const handleOpen1 = () => {
    setConfirmModal(true);
  };
  const handleOpen2 = () => {
    setConfirmModal2(true);
  };
  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null,
      }));
    }

    setTableData([]);
    setHighlightMandatoryFields(false);
  };

  const processProjectList = (projectList) => {
    let processedProjectList = projectList.map(({ ...project }) => {
      const allPlants = project.plants.map((item) => item.name);
      const allVehicleLines = project.vehicleLines;
      const projectCreationDate = moment(project.createdAt).format(
        "DD/MM/YYYY"
      );
      return {
        id: project.id,
        ...project,
        allPlants,
        allVehicleLines,
        projectCreationDate,
      };
    });
    const allPlantsList = [];
    const allVehicleLineList = [];
    processedProjectList.forEach(({ allPlants, vehicleLines }) => {
      allPlantsList.push(...allPlants);
      allVehicleLineList.push(...vehicleLines);
    });

    processedProjectList = processedProjectList.map(({ ...project }) => ({
      ...project,
      allPlants: [...new Set(allPlantsList)],
      allVehicleLines: [...new Set(allVehicleLineList)],
    }));
    return processedProjectList;
  };
  const loadAllProjects = async () => {
    try {
      setRowsData((prev) => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(API_RESOURCE_URLS.PROJECTS);

      const { data: projectList } = response;
      const processedProjectList = processProjectList(projectList);

      setRowsData({
        data: processedProjectList,
        filteredData: processedProjectList,
        loading: false,
      });
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setRowsData({
        data: [],
        filteredData: [],
        loading: false,
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const getSupplierDetails = () => {
    if (suppliers && suppliers.data && supplierCode) {
      const findSupplier = suppliers.data.find(
        (x) => x.code === supplierCode.value
      );
      if (findSupplier) {
        dispatch({
          type: "update",
          field: "supplierDetails",
          value: findSupplier,
        });
        dispatch({
          type: "update",
          field: "supplierName",
          value: findSupplier.name,
        });

        const address = {
          value:
            findSupplier.address[
              Object.keys(findSupplier.address).sort().pop()
            ],
          ...findSupplier.address,
        };
        dispatch({
          type: "update",
          field: "supplierLocation",
          value: Object.values(address)
            .filter((x) => x !== "")
            .join(","),
        });
      }
    }
  };
  const handleRset= (e) =>{
    setState({...myState,toDate:null,fromDate:null,tableFlag:false,Flag:e})
    setProDetails('')
  }

  
  const handleUserRoleDetails= (e) => {
    // console.log(e,'e');
    setState((prevState) => ({ ...prevState, UserRole:e}));
    setState((prevState) => ({ ...prevState, tableFlag: false }));
    
  }


  const baseDefaultColumns = [
 

    {
      width: 100,
      title: "BC No",
      field: "bc_no",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 190,
      title: "BC Description",
      field: "bc_desc",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: "Employee Name",
      field: "employee_name",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: "EMP Ticket No",
      field: "pers_no",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 90,
      title: "Project No",
      field: "project_code",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: "Project Description",
      field: "project_desc",
      enableSearch: true,
      enableFilter: true,
    },

    {
      width: 80,
      title: "EMP Grade Group",
      field: "emp_grade_group",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: "Manager ID",
      field: "manager_id",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: "Manager Name",
      field: "manager_name",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Company",
      field: "company_name",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Booking Date",
      field: "booking_date",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Hrs Available For Booking",
      field: "hrs_available_for_booking",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Applied Date",
      field: "applied_date",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 120,
      title: "Approval Date",
      field: "approval_date",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 80,
      title: "Hours",
      field: "hrs",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 90,
      title: "Month-Year",
      field: "month",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 90,
      title: "Location",
      field: "location",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 140,
      title: "Booking Status",
      field: "booking_status",
      enableSearch: true,
      enableFilter: true,
    },
    // Added for CHG0073013
    {
      width: 140,
      title: "Status",
      field: "status",
      enableSearch: true,
      enableFilter: true,
    }
  ];

  const processPoList = (poList) => {
    const processedPoList = poList.map(({ ...po }) => {
      const plantName = po.plant.name;
      const partDesc = po.part.description;
      const id = po.number;
      const processCreationDate = moment(po.createdAt).format("DD/MM/YYYY");
      return {
        ...po,
        id,
        plantName,
        partDesc,
        processCreationDate,
      };
    });
    return processedPoList;
  };

  const loadPO = async () => {
    try {
      setPOData((prev) => ({
        ...prev,
        loading: true,
      }));

      const response = await API.get(API_RESOURCE_URLS.PURCHASE_ORDER, {
        params: {
          supplierId: supplierDetails ? supplierDetails.id : null,
          partNumber: part ? part.value : null,
          plantCode: plant ? plant.value : null,
          page: poData.number,
        },
      });
      const processedPoList = processPoList(response.data.content);

      setPOData((prev) => ({
        ...prev,
        data: [...prev.data, ...processedPoList],
        filteredData: [...prev.filteredData, ...processedPoList],
        loading: false,
        last: response.data.last,
      }));
    } catch (error) {
      showInternalError(error);
      console.error(buildErrorMessage(error));
      setPOData({
        number: 0,
        data: [],
        filteredData: [],
        loading: false,
        last: false,
      });
    }
  };

  const handleValidation = (event, field) => {
    let err = errors;
    const { value } = event.target;

    switch (field) {
      case "purchaseBuyerName":
        err["purchaseBuyerName"] = value
          ? RegExp(Regex.name).test(value)
            ? ""
            : "Name is invalid"
          : "Name is required";
        break;

      case "suppRepresentativeName":
        err["suppRepresentativeName"] = value
          ? RegExp(Regex.name).test(value)
            ? ""
            : "Name is invalid"
          : "Name is required";
        break;

      case "suppRepresentativeEmail":
        err["suppRepresentativeEmail"] = value
          ? RegExp(Regex.email).test(value)
            ? ""
            : "Email is invalid"
          : "Email is required";
        break;

      case "suppRepresentativeContact":
        err["suppRepresentativeContact"] = value
          ? RegExp(Regex.phone).test(value)
            ? ""
            : "Contact is invalid"
          : "Contact is required";
        break;

      default:
        break;
    }
    dispatch({ type: "update", field: "errors", value: err });
  };

  const handleSearch=()=>{
    window.location.reload()
  }

  

  const renderIndirectProject = () => (
    <div className={styles.formGroup}>
    {userList.length > 1 && 

<Grid
  container
  spacing={1}
  style={{ marginTop: "10px" }}
  className={styles.myGrid}
  columns={6}
>
  
  {MangerFlag ? (
    <>
  <Grid item md={3} lg={3} sm={12}>
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="row-radio-buttons-group"
      markIfUnselected={highlightMandatoryFields}
      resetAllVisitedFields={resetAllVisitedFields}
      style={{
        marginLeft: "10px",
        marginRight: "11px",
        alignItems: "center",
        float: "center",}}
     
         value={myState.UserRole}
          // onChange={(e) => setProDetails(e.target.value)}
          defaultValue=""
          onClick={(e) => handleUserRoleDetails(e.target.value)}
          className={styles.radiobtn}
    >
      
      {/* <FormControlLabel value="Yes" name="status" control={<Radio size="small" />} label="Yes" />
      <FormControlLabel value="No" name="status" control={<Radio size="small" />} label="No" /> */}

      <FormControlLabel
        value="M"
        name="status"
        control={<Radio size="small" />}
        label="Manager"
        style={{ color: "black" }}
        className={styles.radiobtn}
      />
    </RadioGroup>
  </Grid>
  </>
  ): (
    "")}

  {DSFlag ? (
    <>
  <Grid item md={3} lg={3} sm={12}>
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="row-radio-buttons-group"
      required={true}
      // value={typeOfReport}
      // onChange={(event) => setReportType(event.target.value)}
      markIfUnselected={highlightMandatoryFields}
      resetAllVisitedFields={resetAllVisitedFields}
      style={{
        marginLeft: "10px",
        marginRight: "11px",
      }}
          value={myState.UserRole}
          // onChange={(e) => setProDetails(e.target.value)}
          defaultValue=""
          onClick={(e) => handleUserRoleDetails(e.target.value)}
          className={styles.radiobtn} 
    >
      {/* <FormControlLabel value="Yes" name="status" control={<Radio size="small" />} label="Yes" />
      <FormControlLabel value="No" name="status" control={<Radio size="small" />} label="No" /> */}

      <FormControlLabel
        value="DS"
        name="status"
        control={<Radio size="small" />}
        label="Departmental SPOC"
        style={{ color: "black" }}
        className={styles.radiobtn}
      />
    </RadioGroup>
  </Grid>
  </>
  ): (
    "")}

  {SAFlag ? (
    <>
  <Grid item md={3} lg={3} sm={12}>
    <RadioGroup
      row
      aria-labelledby="demo-row-radio-buttons-group-label"
      name="row-radio-buttons-group"
      required={true}
      // value={typeOfReport}
      // onChange={(event) => setReportType(event.target.value)}
      markIfUnselected={highlightMandatoryFields}
      resetAllVisitedFields={resetAllVisitedFields}
      style={{
        marginLeft: "10px",
        marginRight: "11px",
      }}
          value={myState.UserRole}
          // onChange={(e) => setProDetails(e.target.value)}
          defaultValue=""
          onClick={(e) => handleUserRoleDetails(e.target.value)}
          className={styles.radiobtn}
    >
      {/* <FormControlLabel value="Yes" name="status" control={<Radio size="small" />} label="Yes" />
      <FormControlLabel value="No" name="status" control={<Radio size="small" />} label="No" /> */}

      <FormControlLabel
        value="SA"
        name="status"
        control={<Radio size="small" />}
        label="Super Admin"
        style={{ color: "black" }}
        className={styles.radiobtn}
      />
    </RadioGroup>
  </Grid>

  </>
  ): (
    "")}

    
    </Grid>
    }

      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        
        <Grid item md={3} lg={3} sm={6} xs={6}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
              alignItems: "center",
              float: "center",}}
           
               value={myState.Flag}
                onChange={(e) => {
                  // setState({...myState,Flag:e.target.value});
                handleRset(e.target.value);
                }}
              
                defaultValue=""
                // onClick={(e) => handleDateType(e.target.value)}
                className={styles.radiobtn}
          >
            <FormControlLabel
              value="B"
              name="Flag"
              control={<Radio size="small" />}
              label="Booking Date"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>
      
        <Grid item md={3} lg={3} sm={6} xs={6}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}
            // value={typeOfReport}
            // onChange={(event) => setReportType(event.target.value)}
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            style={{
              marginLeft: "10px",
              marginRight: "11px",
            }}
                value={myState.Flag}
                onChange={(e) => {
                  // setState({...myState,Flag:e.target.value})
                  handleRset(e.target.value); 
                }}
                defaultValue=""
                // onClick={(e) => handleDateType1(e.target.value)}
                className={styles.radiobtn} 
          >
            {/* <FormControlLabel value="Yes" name="status" control={<Radio size="small" />} label="Yes" />
            <FormControlLabel value="No" name="status" control={<Radio size="small" />} label="No" /> */}

            <FormControlLabel
              value="A"
              name="Flag"
              control={<Radio size="small" />}
              label="Approval Date"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>
        
          </Grid>
      {/* {proDetails && ( */}

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                value={myState.fromDate}
                onChange={(e) => {
                  handleDate(e, "fromDate");
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD-MM-yyyy"
                data-testid="date-picker-div-1"
                // style={{ width: "100%" }}
                // maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                // markIfUnselected={highlightMandatoryFields}
                autoOk
                inputVariant="outlined"
                value={myState.toDate}
                onChange={(e) => {
                  handleDate(e, "toDate");
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="DD-MM-YYYY"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD-MM-yyyy"
                data-testid="date-picker-div-1"
                // style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>

        {userList.length == 1 &&
        <Grid item md={4} lg={4} sm={12}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                onClick={() => handleSubmit()}
                // onClick={handleSearch}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                Submit
              </Button>
              <Button
              
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="primary"
                //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                onClick={() =>  handleSearch()}
                // onClick={handleSearch}
                //     disabled={(myState.chassisNo == null)}
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
          </Grid>}


          {userList.length > 1 && 
              <Grid item md={3} lg={3} sm={12}>
              <div className={styles.rowDiv}>
                <div className={styles.formDiv}>
                  <Button
                    className={clsx(
                      styles.actionButton,
                      styles.primaryActionButton
                    )}
                    variant="primary"
                    //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                    onClick={() => handleSubmit()}
                    // onClick={handleSearch}
                    //     disabled={(myState.chassisNo == null)}
                    data-testid="confirm-action"
                    style={{ marginRight: "5px" }}
                  >
                    Submit
                  </Button>
                  <Button
                    className={clsx(styles.actionButton, styles.resetButton)}
                    variant="primary"
                    //   onClick={() => runPreSubmissionChecks() && handleSubmit()}
                    onClick={() =>  handleSearch()}
                    // onClick={handleSearch}
                    //     disabled={(myState.chassisNo == null)}
                    data-testid="confirm-action"
                    style={{ marginRight: "5px" }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
              </Grid>
          
          }

      


      </Grid>
     {/* )} */}

    
    
    </div>
  );
  const newKeySequence = [
    'id',
  'bc_no',
   'bc_desc',
   'employee_name',
  'pers_no',
   'emp_grade_group',
   'manager_id',
   'manager_name',
   'company_name',
   'booking_date',
   'hrs_available_for_booking',
   'applied_date',
   'approval_date',
   'hrs',
   'month',
   'location',
   'booking_status',
];

  function changeKeySequence(data, keySequence) {
    // console.log(data);
    return data.map((dict) => {
      const newDict = {};
      keySequence.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(dict, key)) {
          newDict[key] = dict[key];
        }
      });
      return newDict;
    });
  }

  function downloadExcel(data) {
    const modifiedList = changeKeySequence(data, newKeySequence);
    // console.log(modifiedList);
    const columnsKeys = {
    //  " Work Order": "workorder",
    //     "Work Order Desc": "workorderdesc",
        'id': 'Id',
        "bc_no": "BC No",
         "bc_desc":"BC Desc",
        "employee_name":"Employee Name",
        "pers_no":"EMP Ticket No",
        "project_code":"Project No",
        "project_desc":"Project Description",

         "emp_grade_group":"EMP Grade Group",
        "manager_id":"Manager ID",
        "company_name":"Company",
        "booking_date":"Booking Date",
       "hrs_available_for_booking":"Hrs Available For Booking",
       "applied_date":"Applied Date",
        "approval_date":"Approval Date",
        "hrs":"Hours",
        "month":"Month-Year",
        "location":"Location",
        "booking_status": "Booking Status"}
        modifiedList.forEach((item, index) => {item.id = index + 1;});
    const updateExportData = modifiedList.map(dict => Object.keys(dict).reduce((acc, key) => {
      acc[columnsKeys[key] || key] = dict[key];
      return acc;
    }, {}));
    const sheet = XLSX.utils.json_to_sheet(updateExportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
    XLSX.writeFile(workbook, 'Indirect Project Report.xlsx');
  }
 
  const renderReport = () => (
    <div className={styles.formGroup}>
       {myState.tableFlag && allTableData?.length !== 0 && (
    <>
     <Grid
            container
            spacing={1}
            // className={styles.myGrid}
            style={{ marginTop: "10px" }}
            columns={12}
          >
             {/* <Grid item md={2} lg={2} xs={2} sm={2}>
              <div className={styles.rowDiv}>
                <div className={clsx(styles.lableDiv2)}>
                  <label>Report Details:</label>
                </div>
              </div>
            </Grid> */}
            <Grid item md={12} lg={12} xs={12} sm={10}>
              <div className={styles.formDiv}>
              <div
              className={styles.col2}
              style={{
                width: "100%",
                height: "100%",
                marginTop: "10px"
                }}
              >   
           
            <>
            <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME}/>

              {/* <Table
            viewDisplay={viewDisplay}
            columns={baseDefaultColumns}
            defaultColumns={baseDefaultColumns}
            rowHeight={ROW_HEIGHT}
              rows={tableArray}
            
            secondaryActions={[
              {
                name: "Export",
                getFilteredData: true,
                authOperation: "create-project",
                shouldEnable: (tableArray) => tableArray,
                actionFn: filteredData => {
                  downloadExcel(filteredData)
                },
              },
            ]}
            setAsnCount={setCount}
            isDataLoading={false}
            actionButtons
            //    onRowSelect={(e) => { console.log('onRowSelect call') }}
          />
          <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={allTableData?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                
              /> */}
              </>
          </div>
        </div>
        </Grid>
        </Grid>
        </>
        )}
    </div>
  );

  const renderPBABody = () => (
    <div
      className={styles.formGroup}
    >
      <Grid
        container
        spacing={1}
        style={{marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="dd/mm/yyyy"
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}

                emptyLabel="dd/mm/yyyy"
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Select Work Area</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isDisabled={myState.checkFlag}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={workAreaList}
                value={myState.bodyBuilder}
                name="bodyBuilder"
              />
            </div>
          </div>
          {myState.bodyBuilderFlag && (
            <div style={{ marginLeft: "81px" }} className={styles.error}>
              Body builder Code is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Select BC No.</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={bcNoList}
                value={myState.chassisNo}
                name="rso"
                jointOption={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px", justifyContent: "center" }}
        columns={12}
      >
        <Grid item md={4} lg={3}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                View
              </Button>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px", width: "fit-content" }}
              >
                Export To Excel
              </Button>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={handleOpen}
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderBARBody = () => (
    <div
      className={styles.formGroup}
      
    >
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >

        <Grid item md={12} lg={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            required={true}
            markIfUnselected={highlightMandatoryFields}
            resetAllVisitedFields={resetAllVisitedFields}
            
          >
            <FormControlLabel
              value="booking"
              name="status"
              control={<Radio size="small" />}
              label="Booking Datewise"
            />
            <FormControlLabel
              value="approval"
              name="status"
              control={<Radio size="small" />}
              label="Approval Datewise"
            />
          </RadioGroup>
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                emptyLabel="dd/mm/yyyy"
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                
                inputProps={{
                  className: clsx(styles.select, styles.dateInput),
                }}
                
                emptyLabel="dd/mm/yyyy"
                
                format="DD/MM/yyyy"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                
              />
            </div>
          </div>
          {myState.handoverDateFlag && (
            // <div style={{ "display": "block" }}  className={styles.invalidfeedback}>Reported date should not be less than invoice date</div>
            <div style={{ marginLeft: "35px" }} className={styles.error}>
              Inserted On is mandatory field
            </div>
          )}
        </Grid>
      </Grid>
      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px" }}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Select Work Area</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                isDisabled={myState.checkFlag}
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={workAreaList}
                value={myState.bodyBuilder}
                name="bodyBuilder"
              />
            </div>
          </div>
          {myState.bodyBuilderFlag && (
            <div style={{ marginLeft: "81px" }} className={styles.error}>
              Body builder Code is mandatory field
            </div>
          )}
        </Grid>

        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>Select BC No.</label>
            </div>
            <div className={styles.formDiv}>
              <CustomSelect
                className={clsx(styles.select, styles.sel2)}
                isMulti
                isClearable
                options={bcNoList}
                value={myState.chassisNo}
                name="rso"
                jointOption={false}
              />
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        className={styles.myGrid}
        style={{ marginTop: "10px", justifyContent: "center" }}
        columns={12}
      >
        <Grid item md={4} lg={3}>
          <div className={styles.rowDiv}>
            <div className={styles.formDiv}>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px" }}
              >
                View
              </Button>
              <Button
                className={clsx(
                  styles.actionButton,
                  styles.primaryActionButton
                )}
                variant="primary"
                data-testid="confirm-action"
                style={{ marginRight: "5px", width: "fit-content" }}
              >
                Export To Excel
              </Button>
              <Button
                className={clsx(styles.actionButton, styles.resetButton)}
                variant="tertiary"
                onClick={handleOpen}
                style={{ marginRight: "5px" }}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const getSelectedFields = () => ({
    projectId: selectedProject,
    poNumber: selectedPO,
    commodityGroupId: purchaseCommodity && purchaseCommodity.value,
    aqCommodityGroupId: aqCommodity && aqCommodity.value,
    purchaseBuyerName: inputFields?.purchaseBuyerName,
    kamContactDetails: {
      // id: inputFields,
      name: inputFields?.suppRepresentativeName,
      contactNumber: inputFields?.suppRepresentativeContact,
      emailId: inputFields?.suppRepresentativeEmail,
    },
  });

  const validateFields = (fields) => {
    const requiredFields = { ...fields, ...fields.kamContactDetails };
    const hasMissingRequiredFields = Object.values(requiredFields).some(
      (field) => !field
    );

    const hasError = Object.values(errors).some((err) => err);

    if (hasMissingRequiredFields || hasError) {
      return false;
    }
    return true;
  };

  const runPreSubmissionChecks = () => {
    const selectedFields = getSelectedFields();
    const areFieldsValid = validateFields(selectedFields);

    if (!areFieldsValid) {
      setHighlightMandatoryFields(true);
      // return false;
      return true;
    }
    return true;
  };

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: "",
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.formContainer
        )}
      >
          <>
            <CustomFormGroup
              header="Indirect Project Report"
              body={renderIndirectProject()}
            />
            {myState.tableFlag && tableData.length === 0 && (
              <>
              {renderReport()}
              </>
            )}
          {loadings ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>):""}
          </>
        
      </div>
     <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox,
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ReportForm.propTypes = {
  redirectToProcessPage: PropTypes.func,
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired,
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam)),
});
ReportForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object,
};
const App = connect(mapStateToProps, mapDispatchToProps)(ReportForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);